import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./AdminNavbar.css";
import logo from "../Assets/images/logo.png";
import {
  LayoutDashboard,
  Package,
  PackagePlus,
  ClipboardList,
  MessageSquare,
  Power,
  Menu,
  X,
} from "lucide-react";
import { useStateValue } from "../../StateProvider";
import { account } from "../../appwrite";

const NAV = [
  { label: "Dashboard", path: "/", icon: LayoutDashboard },
  { label: "All Products", path: "/d/all-products", icon: Package },
  { label: "Add Product", path: "/d/add-product", icon: PackagePlus },
  { label: "Orders", path: "/d/orders", icon: ClipboardList },
  { label: "Live Chat", path: "/d/live-chat", icon: MessageSquare },
];

export default function AdminNavbar() {
  const [, dispatch] = useStateValue();
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSignOut = async () => {
    try {
      await account.deleteSession("current");
    } catch {}
    dispatch({ type: "SET_USER", user: null });
    navigate("/login");
  };

  return (
    <nav className="admin-nav">
      <div className="admin-nav__inner">
        {/* Logo */}
        <a href="/" className="admin-nav__logo-link">
          <img src={logo} alt="TrendBay" className="admin-nav__logo" />
          <span className="admin-nav__badge">Admin</span>
        </a>

        {/* Links (desktop) */}
        <div className="admin-nav__links">
          {NAV.map(({ label, path, icon: Icon }) => (
            <Link
              key={path}
              to={path}
              className={`admin-nav__link ${location.pathname === path ? "admin-nav__link--active" : ""}`}
            >
              <Icon size={15} />
              {label}
            </Link>
          ))}
        </div>

        {/* Hamburger (mobile only) */}
        <button className="admin-nav__hamburger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
          {menuOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {/* Mobile drawer */}
      {menuOpen && (
        <div className="admin-nav__drawer-backdrop" onClick={() => setMenuOpen(false)}>
          <div className="admin-nav__drawer" onClick={(e) => e.stopPropagation()}>
            {NAV.map(({ label, path, icon: Icon }) => (
              <Link
                key={path}
                to={path}
                className={`admin-nav__drawer-link ${location.pathname === path ? "admin-nav__drawer-link--active" : ""}`}
                onClick={() => setMenuOpen(false)}
              >
                <Icon size={18} />
                {label}
              </Link>
            ))}
            <div className="admin-nav__drawer-divider" />
            <button
              className="admin-nav__drawer-signout"
              onClick={() => { handleSignOut(); setMenuOpen(false); }}
            >
              <Power size={18} />
              Sign Out
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
